<template>

<com-item name="players.newcomers" :has-more="true" v-on:more="onMoreClick" :size="size" :is-list="true" :loading="loading" :is-empty="!active" title="Newcomers">

	<template v-slot:stats>

		<app-user type="player" :item="item" v-for="(item, index) in data" subdate="Played :game on" :key="index" />

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'your', 'you', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

		loading: function() {

			return this.fetching === 'all' 

		},

		data: function() {

			return this.$store.getters['page/insights/players/newcomers']

		},

		active: function() {

			return this.data.length && !this.loading

		}

	},

	methods: {

		onMoreClick: function() {
		
			this.$pubsub.$emit('panel.open', {
				type: 'insightsPlayersNewcomers'
			})
		
		}

	}

}

</script>

<style scoped>

</style>